//Add lozad intersection observer polyfill for older browsers
require('intersection-observer');

//Load JS Cookie
const Cookies = require('js-cookie');

//Add native bootstrap components we need only
import Tooltip from 'bootstrap.native/dist/components/tooltip-native.esm.js';
import Dropdown from 'bootstrap.native/dist/components/dropdown-native.esm.js';
import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js';

//Add sal for HTML animations
import sal from 'sal.js/dist/sal.js';

//Add lozad for lazy loading images and videos
import lozad from 'lozad';

const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

//Smooth scroll for the Trust Center page
import SmoothScroll from 'smooth-scroll/dist/smooth-scroll.min.js';
var scroll = new SmoothScroll('a.button.filter-button[href*="#"]');

let lang = window.navigator.languages ? window.navigator.languages[0] : null;
lang =
  lang ||
  window.navigator.language ||
  window.navigator.browserLanguage ||
  window.navigator.userLanguage;

let shortLang = lang;
if (shortLang.indexOf('-') !== -1) shortLang = shortLang.split('-')[0];

if (shortLang.indexOf('_') !== -1) shortLang = shortLang.split('_')[0];

//Try to automatically send FR/DE/ES traffic to their home page unless they specified a lang pref
if (window.location.pathname === '/') {
  if (typeof Cookies.get('langPref') == 'undefined') {
    if (shortLang !== 'en') {
      if (shortLang === 'fr') window.location = '/fr/' + window.location.search;
      if (shortLang === 'es') window.location = '/es/' + window.location.search;
      if (shortLang === 'de') window.location = '/de/' + window.location.search;
    }
  } else {
    if (Cookies.get('langPref') === 'lang-fr')
      window.location = '/fr/' + window.location.search;
    if (Cookies.get('langPref') === 'lang-es')
      window.location = '/es/' + window.location.search;
    if (Cookies.get('langPref') === 'lang-de')
      window.location = '/de/' + window.location.search;
  }
}

document.addEventListener('DOMContentLoaded', function (e) {
  // update space nav
  function updateSpaceNav() {
    const topBanner = document.querySelector('.top-banner-cookie');
    const hv2Main = document.querySelector('.hv2-main');
    const hv2Nav = document.querySelector('.hv2-top-nav');
    const dropdowns = document.querySelectorAll(
      '.hv2-top-nav .nav-item.dropdown'
    );

    if (hv2Main && topBanner) {
      hv2Main.style.marginTop = `${topBanner.offsetHeight}px`;
    }

    if (dropdowns.length > 0 && hv2Nav) {
      for (let i = 0; i < dropdowns.length; i++) {
        const dropdownMenu = dropdowns[i].querySelector('.dropdown-menu');
        if (dropdownMenu) {
          dropdownMenu.style.top = `${hv2Nav.offsetHeight}px`;
        }
      }
    }
  }

  updateSpaceNav();
  window.addEventListener('resize', updateSpaceNav);

  //assign cookie for lang pref to overide home page auto redirect away from EN
  const langTriggers = document.querySelectorAll(
    '#langDropdown + .dropdown-menu a.dropdown-item'
  );
  for (const langTrigger of langTriggers) {
    langTrigger.addEventListener('click', function (event) {
      Cookies.set('langPref', this.id);
    });
  }

  //lazy load wistia js
  const wistiaTriggers = document.querySelectorAll(
    '.wistia_embed button,.wistia_embed .button, .wistia_embed .hv2-button-play'
  );

  if (wistiaTriggers) {
    window._wq = window._wq || [];
    for (const wistiaTrigger of wistiaTriggers) {
      wistiaTrigger.addEventListener('click', function (event) {
        var ev1 = document.createElement('script');
        ev1.src = '//fast.wistia.com/assets/external/E-v1.js';
        ev1.async = true;
        ev1.charset = 'ISO-8859-1';
        document.head.appendChild(ev1);

        let videoId = wistiaTrigger.dataset.wistiaId;

        _wq.push({
          id: videoId,
          onReady: function (video) {
            video.play();
          }
        });
      });
    }
  }

  //force wistia load if wvideo param is set
  const urlParams = new URLSearchParams(window.location.search);
  const wistiaParam = urlParams.get('wvideo');
  if (wistiaParam) {
    console.log(wistiaParam);
    var qv1 = document.createElement('script');
    qv1.src = '//fast.wistia.com/assets/external/E-v1.js';
    qv1.async = true;
    qv1.charset = 'ISO-8859-1';
    document.head.appendChild(qv1);

    let videoId = wistiaParam;

    _wq.push({
      id: videoId,
      onReady: function (video) {
        video.play();
      }
    });
  }

  const doc = document.documentElement;

  var prevScroll = window.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;

  const header = document.getElementById('myNavbar');

  const toggleHeader = function (direction, curScroll) {
    if (!document.querySelector('#mainNav').classList.contains('show')) {
      if (direction === 2 && curScroll > 118) {
        header.classList.add('hide');
        prevDirection = direction;
      } else if (direction === 1) {
        header.classList.remove('hide');
        prevDirection = direction;
      }
    }
  };

  const navbar_style = document.querySelector('.navbar');
  const body_style = document.querySelector('body');
  const checkScroll = function () {
    /*
     ** Find the direction of scroll
     ** 0 - initial, 1 - up, 2 - down
     */
    add_space_nav();
    curScroll = window.scrollY || doc.scrollTop;
    // 1 for scrolled up, 2 for scrolled down
    direction = curScroll > prevScroll ? 2 : 1;

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }

    prevScroll = curScroll;
  };

  window.addEventListener('scroll', checkScroll);

  window.addEventListener('resize', function () {
    add_space_nav();
  });

  const add_space_nav = () => {
    if (document.querySelector('.leadinModal-theme-top')) {
      const space_top = document.querySelector(
        '.leadinModal-theme-top'
      ).clientHeight;
      navbar_style.style.marginTop = space_top + 'px';
      body_style.style.marginTop = space_top + 'px';
      document
        .querySelector('.leadinModal-close')
        .addEventListener('click', function () {
          navbar_style.style.marginTop = '0';
          body_style.style.marginTop = '0';
        });
    } else {
      navbar_style.style.marginTop = '0';
      body_style.style.marginTop = '0';
    }
  };

  // Non transparent once past header
  const navbar = document.querySelector('.navbar');
  const spot = document.querySelector('.hero-section');
  const firstSection = document.querySelector('main section:first-of-type');

  const options = {
    root: null,
    rootMargin: '0px',
    threshhold: 0
  };

  const handleScroll = (entries) => {
    const spotIsVisible = entries[0].isIntersecting;

    if (spotIsVisible) {
      navbar.classList.remove('white');
    } else {
      navbar.classList.add('white');
    }
  };

  const observer = new IntersectionObserver(handleScroll, options);
  if (spot) {
    observer.observe(spot);
  } else if (firstSection) {
    observer.observe(firstSection);
  }

  /*open all external links in a new tab
  let links = document.links;
  for (var i = 0, linksLength = links.length; i < linksLength; i++) {
    if (
      links[i].hostname != window.location.hostname &&
      !links[i].classList.contains('login-link')
    ) {
      links[i].target = '_blank';
      links[i].rel = 'noopener';
    }
  }*/

  let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  //swap out cta links for mobile
  if (isMobile) {
    let mobileSignupLinks = document.querySelectorAll('a[data-mobile-signup]');
    if (mobileSignupLinks) {
      mobileSignupLinks.forEach(function (elem) {
        //swap the link with the data-mobile-signup value
        elem.setAttribute('href', elem.dataset.mobileSignup);
        elem.removeAttribute('target');
      });
    }
  }

  //loop feature videos on hover
  /*let featureClips = document.querySelectorAll('#highlights article');
  if(featureClips) {
    featureClips.forEach(function(elem) {
        elem.addEventListener('mouseover', function(){
          elem.querySelector('video').play();
        });
        elem.addEventListener('mouseout', function(){
          elem.querySelector('video').pause();
        });
    });
  }*/

  //initialize sal.js library used for animations
  sal({
    threshold: 0.33
  });

  //init global nav mobile collapse
  let myCollapseInit = new Collapse('button#navcollapse');

  //dropdown menus must be manually initialized
  const productDropdown = document.querySelector('#productDropdown');
  const platformsDropdown = document.querySelector('#platformsDropdown');
  const resourcesDropdown = document.querySelector('#resourcesDropdown');
  const langDropdown = document.querySelector('#langDropdown');

  if (productDropdown) {
    new Dropdown('#productDropdown', true);
  }
  if (platformsDropdown) {
    new Dropdown('#platformsDropdown', true);
  }
  if (resourcesDropdown) {
    new Dropdown('#resourcesDropdown', true);
  }
  if (langDropdown) {
    new Dropdown('#langDropdown', true);
  }

  //init tooltip on all elements with title attribute
  let elementsTooltip = document.querySelectorAll('.has-tooltip[title]');
  // attach a tooltip for each
  Array.from(elementsTooltip).map(
    (tip) =>
      new Tooltip(tip, {
        placement: 'bottom',
        animation: 'slideNfade',
        delay: 200
      })
  );

  // Hubspot page tagging
  var _hsq = (window._hsq = window._hsq || []);
  _hsq.push(['setContentType', 'site-page']);

  //cookies notice
  var createCookieNotice = function (name, value, days, domain) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie =
      name + '=' + value + expires + '; domain=' + domain + '; path=/';
  };

  //cookies top banner
  var createCookieBannerTop = function (name, value, days, domain) {
    var expires = '';
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toGMTString();
    }
    document.cookie =
      name + '=' + value + expires + '; domain=' + domain + '; path=/';
  };

  //Domain local and beta/prod variable
  if (window.location.hostname === 'localhost') {
    var domain_variable = window.location.hostname;
  } else {
    var domain_variable = 'agorapulse.com';
  }

  var deleteLink = document.querySelector('.cookie-notice-visible');
  var btn_cookies_close = document.querySelector('.close-modal-cookies');

  var activeCookies = document.querySelector('.active-cookies');
  if (activeCookies) {
    document.querySelector('.active-cookies').addEventListener('click', () => {
      createCookieNotice('cookie_notice_accepted', true, 30, domain_variable);

      deleteLink.classList.remove('show-cookie');
    });
    btn_cookies_close.addEventListener('click', function (event) {
      event.preventDefault();
      createCookieNotice('cookie_notice_accepted', true, 30, domain_variable);
      deleteLink.classList.remove('show-cookie');
    });
  }

  var topBannerCookie = document.querySelector('.top-banner-cookie');
  var buttonCookie = document.querySelector(
    '.top-banner-cookie .button-cookie'
  );
  var closeModalCookie = document.querySelector(
    '.top-banner-cookie .close-modal-cookie'
  );

  if (topBannerCookie && buttonCookie) {
    buttonCookie.addEventListener('click', (event) => {
      event.preventDefault();
      //createCookieBannerTop('cookie_top_banner_accepted', true, 30, domain_variable);
      createCookieBannerTop(
        topBannerCookie.dataset.cookieName,
        true,
        30,
        domain_variable
      );
      topBannerCookie.classList.remove('show-cookie');
      //window.location.href = event.currentTarget.href;
      window.open(event.currentTarget.href, '_blank');
    });
  }

  if (topBannerCookie && closeModalCookie) {
    closeModalCookie.addEventListener('click', (event) => {
      event.preventDefault();
      createCookieBannerTop(
        topBannerCookie.dataset.cookieName,
        true,
        30,
        domain_variable
      );
      topBannerCookie.classList.remove('show-cookie');

      // update space nav
      const hv2Main = document.querySelector('.hv2-main');
      const dropdowns = document.querySelectorAll(
        '.hv2-top-nav .nav-item.dropdown'
      );

      if (hv2Main) {
        hv2Main.style.marginTop = '';
      }
      if (dropdowns.length > 0) {
        for (let i = 0; i < dropdowns.length; i++) {
          const dropdownMenu = dropdowns[i].querySelector('.dropdown-menu');
          if (dropdownMenu) {
            dropdownMenu.style.top = '';
          }
        }
      }
    });
  }

  // Get the value of a cookie function
  function getCookie(cName) {
    const name = cName + '=';
    const cDecoded = decodeURIComponent(document.cookie); //to be careful
    const cArr = cDecoded.split('; ');
    let res;
    cArr.forEach((val) => {
      if (val.indexOf(name) === 0) res = val.substring(name.length);
    });
    return res;
  }

  // Check if a cookie exists otherwise display the cookie consent message
  /*function cookieMessage() {
    if (!getCookie('cookie_notice_accepted')) {
      if(deleteLink){
        deleteLink.classList.add('class', 'show-cookie');
      }
    }
    if (!getCookie(topBannerCookie.dataset.cookieName) && topBannerCookie) {
      topBannerCookie.classList.add('show-cookie');
    }
  }
  window.addEventListener('load', cookieMessage);*/

  window.addEventListener('scroll', function () {
    var nav = document.querySelector('.navbar.hv2-top-nav');
    if (nav) {
      var scrolled = window.scrollY > 0;
      nav.classList.toggle('scrolled', scrolled);
    }
  });

  var headerBigMenu = document.querySelector('#myNavbar.hv2-big-menu'); // Make sure the selector is correct
  var dropdownsBigMenu = document.querySelectorAll('#myNavbar .dropdown'); // Target the dropdowns, not the toggle buttons

  // Function to add the 'clicked' class
  function addClickedClass() {
    headerBigMenu.classList.add('clicked');
  }

  // Function to remove the 'clicked' class
  function removeClickedClass() {
    setTimeout(function () {
      // Check if no other dropdown is open before removing the class
      if (!document.querySelector('.dropdown.show')) {
        headerBigMenu.classList.remove('clicked');
      }
    }, 100); // Delay in milliseconds, adjust as needed
  }

  // Add event listeners to dropdown elements
  dropdownsBigMenu.forEach(function (dropdown) {
    // When the dropdown is shown
    dropdown.addEventListener('show.bs.dropdown', addClickedClass);

    // When the dropdown is hidden
    dropdown.addEventListener('hide.bs.dropdown', removeClickedClass);
  });
});
